export interface MmiLatLng {
  lat: number;
  lng: number;
}
